<template>
  <div class="chart-container">
    <highcharts ref="chart" :options="chartOptions" />

    <div class="state-label" v-if="!requested">Press Search Button</div>
    <div class="state-label" v-else-if="loading">Loading...</div>
    <div class="state-label" v-else-if="!ecg1.length">No Data.</div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
export default {
  props: {
    device: {type: Object, required: true},
    date: {type: String, default: moment().format('YYYY-MM-DD')}
  },
  methods: {
    async getData () {
      this.requested = true
      this.loading = true
      this.ecg1 = []
      this.ecg2 = []
      this.spo2 = []
      this.resp = []

      const r = {}, maxsec = 1441
      r.ecg1 = _.times(maxsec, (n) => ([n, null]))
      r.ecg2 = _.times(maxsec, (n) => ([n, null]))
      r.spo2 = _.times(maxsec, (n) => ([n, null]))
      r.resp = _.times(maxsec, (n) => ([n, null]))

      let {data} = await this.$sock(`device/history/${this.device.dseq}/${this.date}/gmt/${moment().utcOffset()}`)

      let starttime = moment(this.date).valueOf()
      for (let record of data.records) {
        let min = (moment(record.created, 'YYYYMMDDHHmm').valueOf() - starttime) / 60000
        if (min > 1440) {
          console.log(`overvalue: min:${min}`)
          continue;
        }
        r.ecg1[min][1] = record.ecg1
        r.ecg2[min][1] = record.ecg2
        r.spo2[min][1] = record.spo2
        r.resp[min][1] = record.resp
      }
      this.ecg1 = r.ecg1
      this.ecg2 = r.ecg2
      this.spo2 = r.spo2
      this.resp = r.resp
      this.loading = false
    }
  },
  computed: {
    chartOptions () {
      return {
        title: {text: null},
        credits: {enabled: false},
        chart: {
          height: 384,
          backgroundColor: 'transparent'
        },
        series: [
          { name: 'ECG1', type: 'line', color: this.device.ecg1_color, data: this.ecg1 },
          { name: 'ECG2', type: 'line', color: this.device.ecg2_color, data: this.ecg2 },
          { name: 'SPO2', type: 'line', color: this.device.spo2_color, data: this.spo2 },
          { name: 'RESP', type: 'line', color: this.device.resp_color, data: this.resp }
        ],
        legend: {
          layout: 'vertical',
          floating: true,
          align: 'left',
          verticalAlign: 'top',
          backgroundColor: '#FFFFFF',
          x: 30, y: 0,
        },
        plotOptions: {
          line: {
            enableMouseTracking: false,
            lineWidth: 1
          }
        },
        xAxis: {
          categories: _.times(86400),
          labels: {
            formatter: function () {
              if (this.value % 60) return ''
              return this.value / 60
            }
          }
        },
        yAxis: {
          title: {enabled: false},
          gridLineColor: 'rgba(255,255,255,0.2)'
        }
      }
    }
  },
  // mounted () {
  //   console.log('MOUNTED   > SENSOR HISTORY')
  //   this.getData()
  // },
  // beforeDestroy () {
  //   console.log('UNMOUNTED > SENSOR HISTORY')
  // },
  data () {
    return {
      requested: false,
      loading: false,
      ecg1: [], 
      ecg2: [], 
      spo2: [], 
      resp: []
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-container {
  height: 404px;
  margin: 10px; padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.2);
  background-color: rgba(255,255,255,0.16);
  position: relative;
}
.state-label {
  position: absolute;
  top: 50%; left: 50%;
  width: 180px; height: 80px;
  margin: -40px 0 0 -90px;
  display: flex;
  justify-content: center; align-items: center;

  color: white;
  background-color: black;
}
</style>